import { getProxyUrl } from 'academy-common-lib/utils/url';
// @ts-expect-error Could not find a declaration file for module
import defaultShareImage from 'bender-url!../../images/default-share-image.png';
import PublicPageLayout from '../features/publicLayout/components/PublicPageLayout';
import { supportedPublicLanguages } from 'academy-common-lib/constants/academySupportedLanguages';
import DocumentHead from '../features/publicSeo/components/DocumentHead';
import { NavMarker } from 'react-rhumb';
import OpenGraph from '../features/publicSeo/components/OpenGraph';
import I18n from 'I18n';
import { useEffect } from 'react';
import usageTracker from '../utils/usageTracker';
import AlternateLanguageLinks from '../features/publicSeo/components/AlternateLanguageLinks';
import PublicPageHeader from '../features/publicLayout/components/PublicPageHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import HorizontalLayoutContainer from '../features/publicLayout/components/HorizontalLayoutContainer';
import { Section } from 'foundations-components/transitional/components/Section';
import PublicPageAboutAcademySection from '../features/publicPresentation/components/PublicPageAboutAcademySection';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { PublicCatalogDropdown, PublicCatalogSearchInput, PublicCatalogFilters, PublicCatalogMobileFilters, PublicCatalogResults, PublicCatalogResultsBar } from '../features/publicCatalog';
import PublicCatalogMobileCategoriesMenu from '../features/publicCatalog/components/PublicCatalogMobileCategoriesMenu';
import { useLocation } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicCatalogPage = () => {
  const {
    isMobile
  } = useMediaQuery();
  const location = useLocation();
  useEffect(() => {
    document.title = I18n.text('academyPublic.catalogPage.pageTitle');
    usageTracker.track('pageView', {
      screen: 'catalog-page',
      subscreen: 'catalog-page'
    });
  }, []);
  return /*#__PURE__*/_jsxs(PublicPageLayout, {
    availableLanguages: [...supportedPublicLanguages],
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "CATALOG_PAGE_LOAD"
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      errorMessage: null,
      children: /*#__PURE__*/_jsxs(DocumentHead, {
        children: [/*#__PURE__*/_jsx("link", {
          href: getProxyUrl(location.pathname),
          rel: "canonical"
        }), /*#__PURE__*/_jsx(AlternateLanguageLinks, {
          languages: [...supportedPublicLanguages]
        }), /*#__PURE__*/_jsx("meta", {
          content: I18n.text('academyPublic.catalogPage.pageDescription'),
          name: "description"
        }), /*#__PURE__*/_jsx(OpenGraph, {
          description: I18n.text('academyPublic.catalogPage.pageDescription'),
          image: defaultShareImage.replace('//', 'https://'),
          imageAlt: I18n.text('academyPublic.defaultThumbnailAltText'),
          title: I18n.text('academyPublic.catalogPage.pageTitle'),
          url: getProxyUrl(location.pathname)
        })]
      })
    }), /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(PublicPageHeader, {
        badgeText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.catalogPage.badgeText"
        }),
        description: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.catalogPage.description"
          })
        }),
        heading: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.catalogPage.heading"
        }),
        paddingBlockEnd: "50",
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexWrap: isMobile ? 'wrap' : 'nowrap',
          gap: isMobile ? '200' : '600',
          justifyContent: "center",
          marginBlockEnd: isMobile ? undefined : '1000',
          marginBlockStart: "1000",
          children: [!isMobile && /*#__PURE__*/_jsx(PublicCatalogDropdown, {}), /*#__PURE__*/_jsx(Box, {
            flexBasis: "100%",
            flexGrow: 1,
            maxInlineSize: isMobile ? undefined : '400px',
            children: /*#__PURE__*/_jsx(PublicCatalogSearchInput, {})
          }), isMobile && /*#__PURE__*/_jsx(PublicCatalogMobileCategoriesMenu, {})]
        })
      })
    }), /*#__PURE__*/_jsxs(ErrorBoundary, {
      children: [!isMobile && /*#__PURE__*/_jsx(PublicCatalogResultsBar, {}), isMobile && /*#__PURE__*/_jsx(PublicCatalogMobileFilters, {})]
    }), /*#__PURE__*/_jsx(Section, {
      paddingBlockStart: "0",
      children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
        children: [/*#__PURE__*/_jsx(ErrorBoundary, {
          children: !isMobile && /*#__PURE__*/_jsx(PublicCatalogFilters, {})
        }), /*#__PURE__*/_jsx(ErrorBoundary, {
          children: /*#__PURE__*/_jsx(PublicCatalogResults, {})
        })]
      })
    }), /*#__PURE__*/_jsx(Section, {
      marginBlockEnd: "0",
      children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
        children: /*#__PURE__*/_jsx(PublicPageAboutAcademySection, {})
      })
    })]
  });
};
export default PublicCatalogPage;